// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1284":"ef91686d","7024":"b64cfc0d","9229":"cce7b655","9638":"380f3684"}[chunkId] + ".chunk.css");